import { Dialog, Typography } from '@mui/material';

import ContainerLoading from 'portal/src/components/common/ContainerLoading';

const FileUploadPreviewDialog = ({
  open,
  onClose,
  previewSrc,
  isFetchingImg,
  isPdf,
}: {
  open: boolean;
  onClose: () => void;
  previewSrc: string | null;
  isFetchingImg: boolean;
  isPdf: boolean;
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          maxWidth: 1200,
          height: '90vh',
          width: '90vw',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        },
      }}
    >
      {isFetchingImg ? (
        <ContainerLoading additionalLoadingText="statement image" />
      ) : !previewSrc ? (
        <Typography color="error">Unable to load statement image.</Typography>
      ) : isPdf ? (
        <iframe
          title="Statement Image Preview"
          src={previewSrc}
          style={{
            width: '100%',
            height: '100%',
            border: 0,
            display: 'block',
          }}
        />
      ) : (
        <img
          src={previewSrc}
          alt="Preview"
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
      )}
    </Dialog>
  );
};

export default FileUploadPreviewDialog;
